import React, { useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import s from './styles.module.scss';
import { InputAdornment, TextField } from '@mui/material';
import { SearchRounded } from '@mui/icons-material';
import { useRouter } from 'next/router';
import { routes } from '@/infrastructure/const/routes';

interface IAppNavbarSearchInputProps {
  className?: string;
}

const AppNavbarSearchInput: React.FC<IAppNavbarSearchInputProps> = (props) => {
  const { className = '' } = props;

  const [searchValue, setSearchValue] = useState<string>('');
  const { t: tButtons } = useTranslation('buttons');

  const router = useRouter();
  const inputClassNames = classNames(className);
  const inputStyles = {
    height: '39px',
    padding: '8px',
    paddingLeft: '0',
    fontSize: '16px',
  };

  const search = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  };

  const keyPress = (event: any) => {
    const ENTER_BUTTON_CODE = 13;
    if (event.keyCode === ENTER_BUTTON_CODE && searchValue.trim() !== '') {
      router.push(`${routes.search}?search=${searchValue.toLowerCase()}`);
    }
  };

  return (
    <TextField
      variant="standard"
      size="small"
      placeholder={tButtons('search')}
      className={inputClassNames}
      sx={inputStyles}
      InputProps={{
        startAdornment: (
          <InputAdornment
            classes={{
              root: s['icon'],
            }}
            position="start"
          >
            <SearchRounded fontSize="inherit" />
          </InputAdornment>
        ),
      }}
      onKeyDown={keyPress}
      onChange={search}
    />
  );
};

export default AppNavbarSearchInput;
